import {useEffect, useState} from 'react';
import couponImage from '../../assets/image/coupon-image.svg';
// import HubspotForm from 'react-hubspot-form';

export default function CouponModalComponent({onCloseModal}) {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const openModalCoupon = () => {
    onCloseModal(false);
  };

  useEffect(() => {
    dataLayer.push({
      event: 'view_promotion', //Static data
      creative_name:
        'Usa el siguiente código en tu compra para obtener 15% de descuento ', //Dynamic data
      creative_slot: 'destacada_1', //Dynamic data
      promotion_id: '6438710', //Dynamic data
      promotion_name:
        'Usa el siguiente código en tu compra para obtener 15% de descuento ', //Dynamic data
    });
  });

  useEffect(() => {
    if (hasSubmitted) {
      dataLayer.push({
        event: 'select_promotion', //Static data
        creative_name:
          'Usa el siguiente código en tu compra para obtener 15% de descuento ', //Dynamic data
        creative_slot: 'destacada_1', //Dynamic data
        promotion_id: '6438710', //Dynamic data
        promotion_name:
          'Usa el siguiente código en tu compra para obtener 15% de descuento ', //Dynamic data
      });
    }
  }, [hasSubmitted]);
  return (
    <div className="modal-wrapper modal-coupon">
      <div className="modal bg-white p-4 rounded-lg">
        <button
          type="button"
          className="closeModal"
          onClick={() => openModalCoupon()}
        >
          <span className="sr-only">Close Modal</span>
          <CloseIcon />
        </button>
        <div className="coupon-image">
          <img src={couponImage} alt=""></img>
        </div>
        <div className="coupon-info">
          {hasSubmitted ? (
            <div className="mt-5">
              <h2 className="text-center">¡Aquí está tu cupón!</h2>
              <h3 className="text-center">
                Usa el siguiente código en tu compra para obtener{' '}
                <strong>15% de descuento</strong>
              </h3>
            </div>
          ) : (
            <>
              {/* <h2 className="text-center">
                ¡Te he perseguido por dos páginas!
              </h2>
              <h3 className="text-center">
                Queremos regalarte un{' '}
                <strong>cupón del 15% de descuento</strong>
              </h3> */}
            </>
          )}
          <div className="hubspot-form">
            {/* <HubspotForm
              portalId="6438710"
              formId="7e04a182-99e2-4c21-b3dc-2f1c7f12efeb"
              onSubmit={() => setHasSubmitted(true)}
              onReady={(form) => console.log('Form ready!')}
              loading={<div>Loading...</div>}
            /> */}

            <iframe
              className="transparent-iframe discount-iframe"
              allowTransparency="true"
              src="https://cloud.mkt-ellibrero.com/Quierolibros_copia"
              allowFullScreen
            />

            {hasSubmitted ? (
              <></>
            ) : (
              <>
                <p className="text-xs text-center">
                  Acepto y he leído el Aviso de privacidad.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
function CloseIcon() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17L17 1M1 1L17 17"
        stroke="#5A66AD"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
